/**
 * StickyHeader is in /sections/header.liquid
 */

/**
 * HeaderMenu
 * 
 * 如果更改了 transition 动画时长，需要同步更改 closeAnimation() 函数中的时间
 */
class HeaderMenu extends HTMLElement {
  /**
   * 菜单的类型
   * @typedef {MenuType}
   */
  static MenuType = {
    mega: "mega",
    megaProduct: "mega-product",
  };
  /**
   * 标签选择器
   */
  static Selectors = {
    megaAsideItem: ".mega-menu__aside-item.has--children",
    megaSectionTab: ".mega-menu__product-tab",
    megaProductSection: ".mega-menu__product-section",
    megaProductList: ".mega-menu__product-list",
  };
  /** 
   * @returns {MenuType}
   */
  get _menuType() { return this.getAttribute("menu-type") }

  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainDetailsToggle = this.querySelector("details");

    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('mouseenter', () => {
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.classList.add('header-menu--open');
        this.mainDetailsToggle.setAttribute('aria-expanded','true');
      });
      this.mainDetailsToggle.addEventListener('mouseleave', () => {
        this.mainDetailsToggle.classList.remove('header-menu--open');
        this.mainDetailsToggle.setAttribute('aria-expanded','false');
        this.closeAnimation();
      });
      this.mainDetailsToggle.addEventListener('click', (event) => {
        if (event.target == this.mainDetailsToggle)
          event.preventDefault();
      });
    }

    if (this._menuType == HeaderMenu.MenuType.megaProduct) {
      this.initProductsMega();
    }
  }

  /**
   * 产品列表类型的 mega
   */
  initProductsMega() {
    const selectors = HeaderMenu.Selectors;
    $(selectors.megaAsideItem).on("mouseenter", (e) => {
      // 移除 aside 已激活状态
      $(selectors.megaAsideItem + ".active")?.removeClass("active");
      const currentEl = e.currentTarget;
      currentEl.classList.add("active");
      const index = currentEl.getAttribute("data-index");
      // 显示对应的 section，隐藏其他
      $(`${selectors.megaProductSection}`).hide();
      $(`${selectors.megaProductSection}[data-index=${index}]`).show();
    });
    $(selectors.megaSectionTab).on("mouseenter", (e) => {
      // 移除 tab 已激活状态
      $(selectors.megaSectionTab + ".active")?.removeClass("active");
      const currentEl = e.currentTarget;
      const $current = $(currentEl);
      currentEl.classList.add("active");
      const index = currentEl.getAttribute("data-index");
      // 显示对应的 product list，隐藏其他
      $current.closest(selectors.megaProductSection).find(selectors.megaProductList).hide();
      $current.closest(selectors.megaProductSection).find(`${selectors.megaProductList}[data-index=${index}]`).css('display', 'flex');
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  closeAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      // 200 为过渡动画时间
      if (elapsedTime < 200) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        if (!this.mainDetailsToggle.classList.contains("header-menu--open"))
          this.mainDetailsToggle.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

// customElements.define('header-menu', HeaderMenu);


document.addEventListener("DOMContentLoaded", () => {
  const secondary_navs = document.querySelectorAll('.secondary-nav-title')

  secondary_navs.forEach((nav) => {
    nav.addEventListener('mouseenter', function () {
      if (!nav.classList.contains('active')) {
        const parent = nav.closest(".first-nav-box");
        const current_secondary_navs = parent.querySelectorAll('.secondary-nav-title')
        const secondary_pro_lists = parent.querySelectorAll('.three-nav-container')
        const index = nav.getAttribute('index')

        current_secondary_navs.forEach((el) => el.classList.remove("active"));
        nav.classList.add('active')

        secondary_pro_lists.forEach((content) => {
            const sequence = content.getAttribute('index')
            content.classList.remove("active")
            if (index == sequence) {
                content.classList.add("active")
            }
        })

      }
    })
  })


  const other_navs = document.querySelectorAll('.other-nav-title')
  const other_pro_lists = document.querySelectorAll('.four-content')
  const three_level_navs = document.querySelectorAll('.header-three-title')
  const four_level_contents = document.querySelectorAll('.four-content-list')

  other_navs.forEach((nav) => {
    nav.addEventListener('mouseenter', function () {
      if (!nav.classList.contains('active')) {
        const index = nav.getAttribute('aria-label')
        other_navs.forEach((el) => el.classList.remove("active"));
        nav.classList.add('active')

        other_pro_lists.forEach((content) => {
            const sequence = content.getAttribute('title')
            content.classList.remove("active")
            three_level_navs.forEach((el) => el.classList.remove("active"));
            four_level_contents.forEach((el) => el.classList.remove("active"));
            if (index == sequence) {
                content.classList.add("active")
            }
        })

      }
    })
  })

  three_level_navs.forEach((nav) => {
    nav.addEventListener('mouseenter', function () {
      const parent = nav.closest(".secondary-title-list");
      const otherNav = parent.querySelector('.other-nav-title')
      other_navs.forEach((el) => el.classList.remove("active"));
      otherNav.classList.add("active")
      three_level_navs.forEach((el) => el.classList.remove("active"));
      nav.classList.add('active')
      const label = nav.getAttribute('aria-label')

      other_pro_lists.forEach((el) => el.classList.remove("active"));

       four_level_contents.forEach((content) => {
            const title = content.getAttribute('title')
            content.classList.remove("active")
            if (label == title) {
                content.classList.add("active")
            }
        })

    })
  })

});